"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics = {
    tagManager: "GTM-N6WSCL2",
};
exports.default = {
    analytics,
};
//# sourceMappingURL=variables.js.map